import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { payrollProjectSave } from 'api/payroll';
var dataForm = {
  project_name: '',
  project_id: ''
};
export default {
  data: function data() {
    return {
      visible: false,
      dataForm: dataForm,
      dataRule: {
        project_name: [{
          required: true,
          message: this.$t('1029')
        }]
      },
      disabled: false
    };
  },
  methods: {
    init: function init() {
      this.visible = true;
      this.$refs.dataForm && this.$refs.dataForm.resetFields();
    },
    // 解决快速点击问题
    debounce: function debounce(handler, delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        handler();
      }, delay);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;
      this.dataForm.project_name = this.dataForm.project_name.trim();
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this.disabled = true;
          _this.debounce(function () {
            payrollProjectSave(_this.dataForm).then(function (res) {
              _this.disabled = false;
              if (res && res.code === 1) {
                _this.visible = false;
                _this.$emit('refreshTableData');
                _this.$message({
                  type: 'success',
                  message: _this.dataForm.id ? _this.$t('804') : _this.$t('805')
                });
              }
            }).catch(function () {
              _this.visible = false;
              _this.disabled = false;
            });
          }, 500);
        }
      });
    }
  }
};